/* Seven Color UI — reveal, icons, sort, quick add. ~2KB, no deps */
(function () {
  var icons = window.scIcons || '';
  function hydrate(root) {
    (root || document).querySelectorAll('[data-ic]:not([data-ok])').forEach(function (el) {
      el.setAttribute('data-ok', '');
      el.setAttribute('aria-hidden', 'true');
      el.innerHTML = '<svg class="u-i"><use href="' + icons + '#i-' + el.getAttribute('data-ic') + '"></use></svg>';
    });
  }
  function reveal(root) {
    var els = (root || document).querySelectorAll('.u-rv:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }
  function init(root) { hydrate(root); reveal(root); }
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-sort]');
    if (!s) return;
    var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString();
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-quick-add]');
    if (!f || !window.fetch) return;
    e.preventDefault();
    var b = f.querySelector('button'), t = b.innerHTML;
    b.disabled = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +f.querySelector('[name=id]').value, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () {
        b.innerHTML = '✓ Added';
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'sc-quick-add' } }));
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('.cart-count, [data-cart-count], .header-actions__cart-icon .cart-bubble__text-count').forEach(function (n) { n.textContent = c.item_count; });
        });
        setTimeout(function () { b.innerHTML = t; b.disabled = false; }, 1800);
      })
      .catch(function () { f.removeAttribute('data-quick-add'); f.submit(); });
  });
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
